import * as themeBase from './themeBase';

export const { theme } = themeBase;
